<template>
  <div class="tools-probability-box">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-box">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>测录取概率</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row type="flex" justify="space-between" :gutter="16">
      <el-col :span="16">
        <el-row class="tools-box-content">
          <h5>测录取概率</h5>
          <div class="zy-text" v-if="gkInfor.score">
            <div>
              {{ province }} <span></span> {{ gkInfor.subject }} <span></span>
              {{ gkInfor.score }}分<span></span> {{ gkInfor.batch }}
            </div>
            <span class="con-score-span" @click="showGkInforHandler"
              ><img src="../../assets/images/edit.png" />
            </span>
          </div>
          <div class="tools-probability-search">
            <div class="search-img header-search">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-width="100px"
                class="demo-ruleForm"
                @submit.native.prevent
              >
                <el-form-item label="你的目标学校：" prop="scl_name">
                  <el-select
                    v-model="ruleForm.scl_name"
                    filterable
                    remote
                    :remote-method="getSearchSchoolListHandler"
                    :loading="loading"
                    reserve-keyword
                    placeholder="请输入你的目标学校"
                  >
                    <el-option
                      v-for="item in optionsSchool"
                      :key="item.scl_id"
                      :label="item.scl_name"
                      :value="item.scl_name"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button @click="searchProbabilityHandler" class="tools-btn"
                    >开始分析</el-button
                  >
                </el-form-item>
              </el-form>
              <div></div>
            </div>
          </div>
          <div>
            <div id="sse_data" style="line-height: 24px;"></div>
          </div>
          <!-- ai分析可出现的地方 -->
          <!-- <el-row class="tools-probability-list" v-show="showNoStatus">
                        <el-row v-show="percentObj.percent">
                            <h3>录取概率</h3>
                            <div id="toolsCanvas" class="tools-canvas"></div>
                            <div class="tools-probability-score">{{percentObj.percent}}<span>%</span></div>
                            <div class="tools-probability-desc">{{percentObj.msg}}</div>
                        </el-row>
                        <div class="no-data-box" v-if="!percentObj.percent">
                            <img src="../../assets/images/null.png" alt="没有数据">
                            <p v-if="!percentObj.msg">没有查询到录取概率，请调整分数或者批次</p>
                            <p v-else>{{percentObj.msg}}</p>
                        </div>
                    </el-row> -->
          <!-- <el-row v-if="scoreLineList.length > 0" style="margin-top: 12px;">
                        <h4>以下是{{scl_name}}的录取分数线：</h4>
                        <el-table :data="scoreLineList" stripe style="width: 100%" border>
                            <el-table-column prop="year" label="年份" width="85">
                            </el-table-column>
                            <el-table-column label="院校代码" width="150">
                                <template slot-scope="scope">
                                    {{scope.row.scl_code?scope.row.scl_code:'-'}}
                                    {{scope.row.zslx_name?'('+scope.row.zslx_name+')':''}}
                                </template>
                            </el-table-column>
                            <el-table-column label="批次" width="150">
                                <template slot-scope="scope">
                                    {{batchObj[scope.row.local_batch_id].name}}
                                </template>
                            </el-table-column>
                            <el-table-column label="投档分" width="120">
                                <template slot-scope="scope">
                                    {{scope.row.score_min?scope.row.score_min:'-'}}
                                </template>
                            </el-table-column>
                            <el-table-column label="投档分位次" width="120">
                                <template slot-scope="scope">
                                    {{scope.row.min_section?scope.row.min_section:'-'}}
                                </template>
                            </el-table-column>
                            <el-table-column label="录取数" width="110">
                                <template slot-scope="scope">
                                    {{scope.row.real_count?scope.row.real_count:'-'}}
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row> -->
        </el-row>
      </el-col>
      <el-col :span="8" class="tools-box-news">
        <SchoolRank></SchoolRank>
        <News></News>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getSearchSchoolList } from "@/api/zhiyuan";
import { getHistoryData } from "@/api/home";
import { mapState } from "vuex";
import { getToken,getApiSign,getBaseURLs,nowTime,getAesCode } from "@/utils/auth.js";
import { getPercentByScore } from "@/api/tools";
import * as echarts from "echarts5";
import marked from "marked";
export default {
  data() {
    const validateBatch = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择批次"));
      } else {
        callback();
      }
    };
    const validateSchool = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入你的目标学校"));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        local_batch_type: "",
        scl_name: "",
      },
      rules: {
        local_batch_type: [{ trigger: "blur", validator: validateBatch }],
        scl_name: [{ trigger: "blur", validator: validateSchool }],
      },
      gkInfor: {},
      province: "",
      sse_data: "",
      eventSource: null,
      percentObj: "",
      showNoStatus: false,
      scoreLineList: [],
      schoolList: [],
      // batchObj: {
      //     '6':'本科提前批',
      //     '7':'本科一批',
      //     '8':'本科二批',
      //     '10':'专科批',
      //     '11':'专科提前批'
      // },
      scl_name: "",
      loading: false,
      batchObj: {},
      subjectObj: {},
      // options: [{
      //     label: '本科一批',
      //     value: '1',
      //     local_batch_type: '7'
      // },
      // {
      //     label: '本科二批',
      //     value: '2',
      //     local_batch_type: '8'
      // },
      // {
      //     label: '专科批',
      //     value: '3',
      //     local_batch_type: '10'
      // },
      // {
      //     label: '本科提前批',
      //     value: '4',
      //     local_batch_type: '6'
      // },
      // {
      //     label: '专科提前批',
      //     value: '5',
      //     local_batch_type: '11'
      // }],
      options: JSON.parse(sessionStorage.getItem("batchList")),
      optionsSchool: [],
      has_code: 0,
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.user.token,
      isShowGk: (state) => state.user.isShowGk,
      provinceCode: (state) => state.user.provinceCode,
      function_code: (state) => state.user.function_code,
    }),
  },
  watch: {
    token(newVal) {
      if (newVal != "") {
        this.getHistoryDataHandler();
      }
    },
    provinceCode(newVal) {
      if (newVal != "" && localStorage.getItem("isProvince") == "true") {
        this.getHistoryDataHandler();
      }
    },
    isShowGk() {
      if (
        localStorage.getItem("isEdit") == "true" &&
        localStorage.getItem("isProvince") == "false"
      ) {
        this.getHistoryDataHandler();
        localStorage.setItem("isEdit", "false");
      }
    },
    function_code() {
      const tmp = this.function_code.filter((item) => {
        return item.function_code === "F00014";
      });
      if (tmp.length > 0) {
        this.has_code = tmp[0].has_code;
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.batchObj = JSON.parse(sessionStorage.getItem("batchObj"));
      this.subjectObj = JSON.parse(sessionStorage.getItem("subjectObj"));
      this.getAreaHandler();
      const tmp = this.function_code.filter((item) => {
        return item.function_code === "F00014";
      });
      if (tmp.length > 0) {
        this.has_code = tmp[0].has_code;
      }
      this.getHistoryDataHandler();
    }, 300);
  },
  methods: {
    getAreaHandler() {
      const areaInfo = JSON.parse(sessionStorage.getItem("proInfo"));
      this.province = areaInfo.filter((val) => {
        return val.area === this.provinceCode;
      })[0].name;
    },
    showGkInforHandler() {
      this.$store.commit("user/SHOWGKINFOR", true);
    },
    getHistoryDataHandler() {
      this.showNoStatus = false;
      this.$refs.ruleForm.resetFields();
      getHistoryData(localStorage.getItem("area")).then((res) => {
        if (res.status == "200") {
          if (!res.data) {
            this.$store.commit("user/SHOWGKINFOR", true);
          } else {
            const data = res.data;
            const subject = this.subjectObj[data.local_type_id].name;
            const batch = this.batchObj[data.local_batch_type].name;
            this.gkInfor = data;
            this.gkInfor = Object.assign({}, this.gkInfor, {
              subject: subject,
              batch: batch,
              section_line: data.section,
            });
            this.$store.commit("user/EDITGKINFOR", this.gkInfor);
            this.ruleForm = this.gkInfor;
          }
        } else {
          this.$message({
            message: "暂无数据，请重新填写信息",
            type: "error",
          });
          // this.$store.commit('user/EDITGKINFOR',{});
          this.$store.commit("user/SHOWGKINFOR", true);
        }
      });
    },
    canvasHander() {
      var myChart = echarts.init(document.getElementById("toolsCanvas"));
      var option;
      const gaugeData = [
        {
          value: this.percentObj.percent,
          title: {
            offsetCenter: ["0%", "10%"],
          },
          detail: {
            valueAnimation: true,
            offsetCenter: ["0%", "40%"],
          },
        },
      ];
      option = {
        series: [
          {
            type: "gauge",
            startAngle: 90,
            endAngle: -270,
            pointer: {
              show: false,
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#ffa038", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#ff671a", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
            },
            center: ["50%", "50%"],
            radius: "76%",
            axisLine: {
              lineStyle: {
                width: 30,
              },
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              distance: 50,
            },
            data: gaugeData,
            title: {
              fontSize: 14,
            },
            detail: {
              color: "#f5f7fa",
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    searchProbabilityHandler() {
      let that = this;
      if (this.has_code == 0) {
        this.$message({
          message: "您的账户暂未开通此功能",
          type: "warning",
        });
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.getPercentByScore();
          // let area = localStorage.getItem("area");
          // let { score, scl_name, local_type_id } = that.ruleForm;
          // let data = that.options.filter(function(item){
          //     return item.local_batch_id == that.ruleForm.local_batch_type;
          // })
          // let local_batch_type = data[0].local_batch_id;
          // getPercentByScore(area,score,scl_name,local_type_id,local_batch_type).then(res => {
          //     that.showNoStatus = true;
          //     if(res.status == '200') {
          //         that.percentObj = res.data;
          //         this.scl_name = this.ruleForm.scl_name;
          //         this.scoreLineList = res.data.score_line || [];
          //         if(res.data.percent) {
          //             that.$nextTick(
          //                 that.canvasHander()
          //             );
          //         }
          //     } else {
          //         that.percentObj = ''
          //     }
          // })
        }
      });
    },
    getPercentByScore: function() {
      let that = this;
      let data = that.options.filter(function(item) {
        return item.local_batch_id == that.ruleForm.local_batch_type;
      });
      let local_batch_type = data[0].local_batch_id;
      let param = {
        area: localStorage.getItem("area"),
        score: this.ruleForm.score,
        scl_name: this.ruleForm.scl_name,
        local_type_id: this.ruleForm.local_type_id,
        local_batch_type: local_batch_type,
      };
      let encrypted_data_obj = JSON.parse(localStorage.getItem('encrypted_data'))
      encrypted_data_obj.timestamp = nowTime()
      let encrypted_data = getAesCode(encrypted_data_obj)
      param.token = getToken();
      param.client_id = '74450c23fa139888c2240568a276879d'
      param.encrypted_data = encrypted_data
      param.sign = getApiSign(param)
      let ret = ''
      for (const it in param) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(param[it]) + '&'
      }
      ret = ret.substr(0, ret.length - 1)
      var url = getBaseURLs() + "api/gk_tools/getPercentByScore?" + ret;
      let sse_data = "";
      fallbackToFetch();
      async function fallbackToFetch() {
        const response = await fetch(url);
        const reader = response.body.getReader();
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;
          if (new TextDecoder().decode(value).indexOf("DONE") == -1) {
            sse_data += new TextDecoder().decode(value);
          }
          if (new TextDecoder().decode(value).indexOf("message") != -1) {
            sse_data = JSON.parse(new TextDecoder().decode(value)).message;
          }
          if (document.getElementById("sse_data")) {
            document.getElementById("sse_data").innerHTML = marked(sse_data);
          }
          const hrs = document.querySelectorAll("hr");
          hrs.forEach(function(hr) {
            hr.style.marginTop = "16px";
            hr.style.marginBottom = "16px";
          });
        }
      }
    },
    getSearchSchoolListHandler(queryString, cb) {
      if (queryString == "") {
        return;
      }
      this.loading = true;
      getSearchSchoolList(queryString).then((res) => {
        this.loading = false;
        this.optionsSchool = res.data;
      });
    },
    beforeDestroy() {
      if (this.eventSource) {
        this.eventSource.close();
      }
      this.sse_data = ""; // 清空数据
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";
@font-face {
  font-family: "Impact";
  src: url("../../assets/fonts/Impact.ttf");
}
.tools-probability-box {
  @include gwidth;
  .tools-box-content {
    padding: 24px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 1px 2px 0px rgba(44, 46, 51, 0.1);
    margin-top: 24px;
    h5 {
      border-left: 2px solid $common-color;
      border-radius: 1px;
      font-size: 22px;
      font-weight: 600;
      color: #2c2e33;
      padding-left: 8px;
      text-align: left;
      padding-bottom: 0px;
      margin-bottom: 24px;
      margin-top: 0;
    }
  }
  .tools-probability-search {
    background: url("../../assets/images/tools-search-score.png") no-repeat;
    background-size: 100% 100%;
    height: 152px;
    padding: 16px 24px 24px 24px;
    box-sizing: border-box;
    margin-top: 20px;
  }
  .tools-btn {
    width: 136px;
    height: 52px;
    border: none !important;
    background: linear-gradient(90deg, #ffa94a, #ff913c);
    border-radius: 8px;
    font-size: 18px;
    font-weight: 400;
    color: #ffffff;
    border: none;
    margin-left: 14px;
    position: relative;
    top: 40px;
  }
  .tools-probability-list {
    min-height: 240px;
    background: #f5f7fa;
    border: 1px solid #ebedf0;
    border-radius: 8px;
    margin-top: 16px;
    text-align: center;
    padding: 24px;
    box-sizing: border-box;
    h3 {
      font-size: 18px;
      font-weight: 400;
      color: #66605e;
      line-height: 25px;
      margin: 0;
    }
    .tools-probability-desc {
      display: inline-block;
      height: 36px;
      padding: 0 16px;
      background: #fe9f0a;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 36px;
      margin: 0 auto;
      margin-top: -20px;
    }
  }
}
.tools-box-news {
  margin-top: 24px;
}
.zy-text {
  color: #2c2e33;
  position: absolute;
  top: 30px;
  right: 72px;
  z-index: 99;
  font-size: 14px;
  cursor: pointer;
  span {
    width: 1px;
    height: 14px;
    background: #c4c7cc;
    border-radius: 1px;
    display: inline-block;
    margin: 0px 3px;
    position: relative;
    top: 1px;
  }
  .con-score-span {
    position: absolute;
    display: inline-block;
    right: -50px;
    width: 28px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px;
    top: -5px;
    box-shadow: 0px 1px 2px 0px rgba(44, 46, 51, 0.1);
  }
  .con-score-span img {
    width: 14px;
    height: 14px;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.tools-canvas {
  position: relative;
  width: 680px;
  height: 250px;
  top: -10px;
}
.tools-probability-score {
  font-size: 50px;
  font-family: "Impact";
  font-weight: 400;
  text-align: center;
  color: $common-color;
  line-height: 61px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  span {
    font-size: 24px;
    color: #66605e;
    margin-left: 15px;
  }
}
.no-data-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  img {
    width: 110px;
    height: 110px;
  }
  p {
    font-size: 16px;
    text-align: center;
    color: #abaeb3;
    margin-left: -14px;
  }
}
</style>
